import React from 'react';
import {View, Platform} from 'react-native';
import {tID} from '../../../utils/TestIdHelper';
import {useTheme, useThemedStyles} from '../../../theme';
import KeyboardDoneBar from '../KeyboardDoneBar';
import Input from '../Input';
import Text from '../Text';
import makeStyles from './styles';
import {USAFlag} from '../../../utils/SvgIcons';

export default function MobilePhoneInput(props) {
  const {
    phoneNumber = {},
    onChangePhoneNumber = {},
    hasError,
    errorText = 'Please enter a valid Phone Number.',
    inputTitle = 'Mobile Phone Number',
    leftText,
    topMargin = 0,
    placeholder = 'Type Here...',
    inputAccessoryViewID,
    onBlur,
    showFlag = true,
    containerStyle = {},
  } = props;
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View
      testID={tID('MobilePhoneInput-View-Container')}
      style={[{marginTop: topMargin}, containerStyle]}
    >
      <Text
        testID={tID('MobilePhoneInput-Text-Title')}
        variation="Body1SemiBold"
        color={colors.textMuted}
        style={styles.marginBottom12}
      >
        {inputTitle}
      </Text>
      <View style={styles.container}>
        {showFlag && (
          <View style={styles.flagContainer(hasError)}>
            <USAFlag
              testID={tID('MobilePhoneInput-Image-Flag')}
              width={Platform.OS === 'web' ? 48 : 24}
              height={Platform.OS === 'web' ? 48 : 16}
            />
          </View>
        )}
        <View
          style={Platform.OS === 'web' ? styles.flex1Width292 : styles.flex1}
        >
          <Input
            testID={tID('MobilePhoneInput-Input-PhoneNumber')}
            placeholder={placeholder}
            value={phoneNumber}
            onChangeText={onChangePhoneNumber}
            onBlur={onBlur}
            leftText={leftText}
            hasError={hasError}
            keyboardType={'number-pad'}
            maxLength={10}
            textContentType="telephoneNumber"
            autoComplete="tel"
            inputAccessoryViewID={inputAccessoryViewID || 'phoneInputDone'}
          />
        </View>
        {!inputAccessoryViewID && <KeyboardDoneBar nativeID="phoneInputDone" />}
      </View>
      {hasError && errorText.length > 0 && (
        <Text
          testID={tID('MobilePhoneInput-Text-Error')}
          style={styles.errorText}
        >
          {errorText}
        </Text>
      )}
    </View>
  );
}
